import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initCapacitor, isNative } from "./utils/capacitor";

// Initialize Capacitor native features
initCapacitor();

// Force clear all caches on app load to prevent stale data (web only)
if (!isNative && 'caches' in window) {
  caches.keys().then(names => {
    names.forEach(name => caches.delete(name));
  });
}

// Unregister old service workers and register fresh one
// Tito's brief Jun 11, 2026 — skip ALT SW-registrering når vi er på
// /record-replay/* (server-side WYSIWYG-rendering). En mislykket SW-update
// trigger'er React's dev-mode "Uncaught runtime errors" overlay som dækker
// hele viewport'et i den optagede MP4.
const __isRecordRoute = typeof window !== 'undefined' && /^\/record-replay\//.test(window.location.pathname);
if ('serviceWorker' in navigator && !__isRecordRoute) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(reg => reg.unregister());
  }).then(() => {
    window.addEventListener('load', () => {
      // Register the main SW
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          registration.update();
          console.log('BareMC: Service Worker registered with scope:', registration.scope);
        })
        .catch((error) => {
          console.error('BareMC: Service Worker registration failed:', error);
        });
      // The main service-worker.js is our app-wide SW. Background sync for
      // ride media is handled by the same SW (see service-worker.js). We
      // keep ride-sw.js for legacy registration but don't register a second
      // scope to avoid conflicts.
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
